import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION29: PdfComponent = {
  type: 'section',
  id: 's29',
  title: '29. No Partnership or Agency',
  content: [
    {
      type: 'bulletList',
      id: 's29bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'The parties are independent contractors and are not partners, principal and agent, or employer and employee. This Agreement does not establish any joint venture, trust, fiduciary, agency or other relationship between them.',
        },
        {
          copy: 'Neither party shall have, nor represent that it has, any authority to make any commitments on behalf of the other.',
        },
      ],
      prefix: '29',
    },
  ],
};
